import {
  CustomErrorInvariant,
  makeCustomErrorInvariant,
  makeRethrower,
  WatershedError,
  WatershedErrorOptions,
} from './WatershedError';

export class UserInputError extends WatershedError {
  status = 400;
  constructor(message?: string, options?: WatershedErrorOptions) {
    super('BAD_USER_INPUT', message, options);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UserInputError);
    }
    Object.setPrototypeOf(this, UserInputError.prototype);
  }

  static invariant: CustomErrorInvariant =
    makeCustomErrorInvariant(UserInputError);
  static wrapAndRethrow = makeRethrower(UserInputError);
}
